import React, { Component } from 'react';
import styled from 'styled-components';
import KarteStore from '../../store';
import { inject, observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNewspaper, faPen } from '@fortawesome/free-solid-svg-icons';
import { SheetFormat, City } from '../../types';

type Props = { karte?: KarteStore };

const cities: { [k: string]: City } = {
  中原区: City.Nakahara,
  多摩区: City.Tama,
  宮前区: City.Miyamae,
  川崎区: City.Kawasaki,
  幸区: City.Saiwai,
  高津区: City.Takatsu,
  麻生区: City.Aso
};

type State = {
  sheetFormat?: SheetFormat;
  city?: string;
};

@inject('karte')
@observer
class SheetSelection extends Component<Props, State> {
  state: State = {
    sheetFormat: SheetFormat.Customize,
    city: '中原区'
  };

  handleCityChange = (event: React.FormEvent<HTMLSelectElement>) => {
    this.setState({ city: event.currentTarget.value });
    const karte = this.props.karte;
    if (!karte) return;
    karte.selectCityForTemplate(cities[event.currentTarget.value]);
  };

  handleSheetFormatChange(sheetFormat: SheetFormat) {
    this.setState({ sheetFormat: sheetFormat });
  }

  handleClose = () => {
    const { karte } = this.props;
    if (karte) {
      karte.closeSheetSelection();
    }
  };

  handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const { karte } = this.props;
    if (!karte || !this.state.sheetFormat) return;
    karte.changeSheetFormat(this.state.sheetFormat);
    karte.closeSheetSelection();
  };

  stopPropagation = (event: React.FormEvent<HTMLElement>) => {
    event.stopPropagation();
  };
  render() {
    const { karte } = this.props;
    const { sheetFormat } = this.state;
    if (!karte) return;

    return (
      <Wrapper onClick={this.handleClose}>
        <ModalContents onClick={this.stopPropagation}>
          <StyledForm onSubmit={this.handleSubmit}>
            <dl>
              <FormTitle>シートを選ぶ</FormTitle>
              <SelectFormat>
                <SelectItem
                  selected={sheetFormat === SheetFormat.Customize}
                  onClick={() =>
                    this.handleSheetFormatChange(SheetFormat.Customize)
                  }
                >
                  <FontAwesomeIcon icon={faPen} size="4x" />
                  <SelectItemName
                    selected={sheetFormat === SheetFormat.Customize}
                  >
                    カスタマイズシート
                  </SelectItemName>
                </SelectItem>
                <SelectItem
                  selected={sheetFormat === SheetFormat.Template}
                  onClick={() =>
                    this.handleSheetFormatChange(SheetFormat.Template)
                  }
                >
                  <FontAwesomeIcon icon={faNewspaper} size="4x" />
                  <SelectItemName
                    selected={sheetFormat === SheetFormat.Template}
                  >
                    サマリーシート
                  </SelectItemName>
                </SelectItem>
              </SelectFormat>
              {this.renderCitySelection()}
              <SubmitWrapper>
                <Submit
                  type="submit"
                  value="表示"
                  disabled={karte.isFetching}
                  style={{ opacity: karte.isFetching ? 0.5 : 1 }}
                />
              </SubmitWrapper>
            </dl>
          </StyledForm>
        </ModalContents>
      </Wrapper>
    );
  }
  renderCitySelection() {
    const { karte } = this.props;
    if (!karte) return;
    if (this.state.sheetFormat === SheetFormat.Customize) return;
    return (
      <StyledDD>
        <StyledSelect value={this.state.city} onChange={this.handleCityChange}>
          {Object.keys(cities).map(c => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </StyledSelect>
      </StyledDD>
    );
  }
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
`;

const ModalContents = styled.div`
  width: 500px;
  height: 330px;
  position: absolute;
  padding: 10px 20px;
  border: 1px solid #999;
  background: white;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
`;

const StyledForm = styled.form`
  margin-top: 25px;
`;

const FormTitle = styled.dt`
  font-size: 22px;
  color: #555;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
`;

const StyledDD = styled.dd`
  margin: 5px 0 10px;
`;

const SelectFormat = styled(StyledDD)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SelectItem = styled.div<{ selected: boolean }>`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  border: solid 1px ${props => (props.selected ? `#4a90e2` : `#999`)};
  color: ${props => (props.selected ? `#4a90e2` : `#999`)};
  border-radius: 3px;
  margin: 5px;
  width: 100%;
  padding: 20px;
  cursor: pointer;
`;

const SelectItemName = styled.p<{ selected: boolean }>`
  font-size: 16px;
  color: ${props => (props.selected ? `#4a90e2` : `#999`)};
  font-weight: ${props => (props.selected ? 'bold' : `normal`)};
  margin-top: 12px;
`;

const StyledSelect = styled.select`
  padding: 5px 0;
  border: solid 1px #ccc;
  border-radius: 3px;
  width: 100%;
  font-size: 12px;
  box-shadow: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  outline: none;
`;

const SubmitWrapper = styled.div`
  text-align: center;
`;

const Submit = styled.input`
  width: 100%;
  outline: none;
  border: none;
  cursor: pointer;
  font-weight: bold;
  padding: 12px 0;
  margin-top: 12px;
  font-size: 16px;
  background: #4a90e2;
  border-radius: 3px;
  color: #fff;
`;

export default SheetSelection;
